<script lang="ts">
    import { onDestroy, onMount } from "svelte";

    import type Connection from "../clienthandler";
    import DefaultContainer from "../DefaultContainer.svelte";
    import { state } from "../state";

    $: connection = $state.connection;

    let joinCodeText = "";

    $: {
        joinCodeText = joinCodeText
            .split("")
            .filter((c) => {
                const code = c.charCodeAt(0);
                return code >= "0".charCodeAt(0) && code <= "9".charCodeAt(0);
            })
            .join("")
            .slice(0, 6);
    }

    $: joinCodeValid = joinCodeText.length === 6;

    let joinPromise;

    $state.connection.registerMessageListener("menu", (message) => {
        switch (message.type) {
            case "LobbyCreated":
                $state.lobbyId = message.lobbyId;
                connection.joinLobby($state.lobbyId);
                break;
            case "LobbyJoined":
                $state.currentPage = "lobby";
                if ($state.lobbyId == null) {
                    $state.lobbyId = parseInt(joinCodeText);
                }
                break;
            case "QuickPlayJoined":
                $state.currentPage = "quickplay_lobby";
                break;
        }
    });
    onDestroy(() => $state.connection.unregisterMessageListener("menu"));

    // $state.connection.registerMessageListener((message) => {
    //     if (message.type === "ConnectedToServer") {
    //         quickPlay();
    //     }
    // });
</script>

<DefaultContainer>
    <h1>Menu</h1>
    {#if joinPromise != null}
        {#await joinPromise}
            <p>Joining...</p>
        {:then _}
            <p>Joined!</p>
        {:catch error}
            <p style="color: red">error: {JSON.stringify(error)}</p>
        {/await}
    {/if}

    <button on:click={() => connection.quickPlay()}>Quick Play</button>
    <button on:click={() => connection.createLobby()}>Create Game</button>
    <button
        disabled={!joinCodeValid}
        on:click={() => connection.joinLobby(parseInt(joinCodeText))}
        >Join Game</button
    >
    <input type="text" bind:value={joinCodeText} placeholder="game code" />
</DefaultContainer>

<style>
    button {
        width: 250px;
    }
    input[type="text"] {
        width: 250px;
    }
</style>
